export default __webpack_public_path__ + "static/media/i_bus-gen_pp.f3cfc8a2.svg";